import { render, staticRenderFns } from "./videoParams.vue?vue&type=template&id=71e227b8&scoped=true"
import script from "./videoParams.vue?vue&type=script&lang=js"
export * from "./videoParams.vue?vue&type=script&lang=js"
import style0 from "./videoParams.vue?vue&type=style&index=0&id=71e227b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e227b8",
  null
  
)

export default component.exports